import LandingBackground from '../features/outlets/components/LandingBackground'
import OutletSearchCard from '../features/outlets/components/searchOutlets/OutletSearchCard'
import Page from '../features/layout/components/Page'

import styles from './index.module.scss'

function HomePage() {
  console.log('HomePage component rendered')
  console.log('process.env.ENV', process.env.ENV)
  console.log('process.env.NODE_ENV', process.env.NODE_ENV)
  console.log(
    'process.env.INTERNAL_',
    process.env.INTERNAL_CORE_API_URL,
    process.env.INTERNAL_MEDIA_API_URL,
  )

  return (
    <Page>
      <LandingBackground className={styles.imgContainer}>
        <OutletSearchCard />
      </LandingBackground>
    </Page>
  )
}

export default HomePage
